import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPictureInPicture: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="picture-in-picture"><path d="M9.25 17.25H2.75V4.75H19.25V11.25M12.75 14.75H21.25V20.25H12.75V14.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPictureInPicture;
